// Record system constants
export const RECORD_CONSTANTS = {
  // View types
  MANDATORY_VIEW: 'note',
  VIEW_TYPES: {
    NOTE: 'note',
    TASK: 'task',
    CALENDAR: 'calendar',
    MAP: 'map',
    GALLERY: 'gallery',
    GRAPH: 'graph'
  },
  
  // Limits
  EDIT_HISTORY_LIMIT: 10,
  MAX_ATTACHMENT_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_ATTACHMENTS: 20, // Maximum attachments per record
  MAX_TAGS: 50,
  MAX_TITLE_LENGTH: 200,
  MAX_BODY_LENGTH: 500 * 1024, // 500KB
  
  // Animation
  SHAKE_DURATION: 500,
  
  // Error messages (for i18n keys)
  ERRORS: {
    MANDATORY_VIEW_DISABLE: 'errors.mandatoryViewDisable',
    LAST_VIEW_DISABLE: 'errors.lastViewDisable',
    UNAUTHORIZED_EDIT: 'errors.unauthorizedEdit',
    SAVE_FAILED: 'errors.saveFailed'
  }
};

// Display mode constants
export const DISPLAY_MODE = {
  MODAL: 'modal',
  PAGE: 'page'
};

// Record status constants
export const RECORD_STATUS = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
};

// Visibility constants
export const VISIBILITY = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  FRIENDS: 'friends'
};

// Lifecycle status constants
export const LIFECYCLE_STATUS = {
  ACTIVE: 'active',    // Record is active and visible
  DELETED: 'deleted'   // Record is soft-deleted (tombstoned)
  // Future states: 'archived', 'draft'
};

// Attachment file types and MIME types
export const ALLOWED_FILE_TYPES = {
  image: [
    'image/jpeg',
    'image/png', 
    'image/gif',
    'image/webp'
  ],
  video: [
    'video/mp4',
    'video/webm',
    'video/quicktime'
  ],
  audio: [
    'audio/mpeg',
    'audio/wav',
    'audio/ogg',
    'audio/webm',
    'audio/x-m4a',
    'audio/mp4'
  ],
  file: [
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    // Spreadsheets
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    // Data formats
    'text/csv',
    'application/json'
  ]
};